<script lang="ts">
	import type { HeroBlock } from './HeroBlockQuery';
	import { breakpoints } from '@core/tools/Breakpoints.svelte';
	import LinkButton from '@comp/LinkButton.svelte';
	import { ViewController, createViewController } from '$lib/actions/animations/ViewController';
	import { EnterOnView } from '$lib/actions/animations/EnterOnView';
	import AssetGallery from '@atoms/assetGallery/AssetGallery.svelte';

	const { data }: { data: HeroBlock } = $props();

	createViewController();
</script>

{#snippet bottom()}
	<div class="card">
		<h3 class="text:description-large" use:EnterOnView={{ delay: 0.2 }}>{data.subHeader}</h3>
		<p class="text:description" use:EnterOnView={{ delay: 0.25 }}>{data.subDescription}</p>
		{#if data.link}
			<span use:EnterOnView={{ delay: 0.3 }}>
				<LinkButton link={data.link} variant="primary"></LinkButton>
			</span>
		{/if}
	</div>
{/snippet}

<section use:ViewController>
	<div class="content">
		<div class="top">
			<h1 use:EnterOnView class="text:headline-large">{data.headline}</h1>
			<p use:EnterOnView={{ delay: 0.1 }} class="text:description-large">{data.description}</p>
		</div>
		<span use:EnterOnView>
			{#if breakpoints.md}
				{@render bottom()}
			{/if}
		</span>
	</div>
	<div class="media" use:EnterOnView>
		<AssetGallery assets={data.media} />
	</div>

	<span use:EnterOnView>
		{#if !breakpoints.md}
			{@render bottom()}
		{/if}
	</span>
</section>

<style lang="scss">
	section {
		@include layoutBlockGrid;
		@include blockPadding;
	}

	.content {
		display: flex;
		height: 100%;
		flex-direction: column;
		justify-content: space-between;
		z-index: 1;
		grid-column: 1 / -1;
		p {
			padding-top: 47px;
		}

		.top {
			@include md {
				p {
					padding-top: 73px;
					width: cols(5, 4);
					padding-bottom: 136px;
				}
			}
		}

		@include md {
			grid-column: 1 / 6;
		}
	}

	span {
		display: contents;
	}

	.card {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		padding: 40px;
		background-color: hsl(var(--color-primary));
		grid-column: 1 / -1;

		width: 100%;

		p {
			padding: 24px 0;
			width: 250px;
		}

		:global([data-button]) {
			&:hover {
				color: hsl(var(--color-primary));
			}
		}

		@include md {
			width: unset;
			padding: 42px 46px;
			grid-column: unset;
			margin-right: calc(cols(5, 1, false, true) * -1);
			p {
				padding: 31px 0;
				width: 350px;
			}
		}
	}

	.media {
		position: relative;
		grid-column: 1 / -1;
		padding-top: 76px;
		aspect-ratio: 1 / 0.8;

		@include md {
			padding-top: 0;
			grid-column: 6 / -1;
			aspect-ratio: unset;
		}
	}
</style>
